import React from 'react';
import { scaleExpr } from './HeroGrid';

interface StarMarkerProps {
  /** Total size of the SVG (including outer tick marks) at BASE_CELL scale. */
  size?: number;
  delay?: number;
}

/** Renders a crosshair star centered on the cell origin (the grid intersection
 *  at 0,0). HeroDecorations positions the intersection. */
const StarMarker: React.FC<StarMarkerProps> = ({ size = 40, delay = 0 }) => {
  return (
    <span
      aria-hidden
      className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 animate-plus-blink"
      style={{
        width: scaleExpr(size),
        height: scaleExpr(size),
        animationDelay: `${delay}s`,
      }}
    >
      <svg viewBox="0 0 48 48" width="100%" height="100%" fill="none">
        {/* Outer crosshair tick marks */}
        <g stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round">
          <line x1="24" y1="2"  x2="24" y2="7"  />
          <line x1="24" y1="41" x2="24" y2="46" />
          <line x1="2"  y1="24" x2="7"  y2="24" />
          <line x1="41" y1="24" x2="46" y2="24" />
        </g>
        {/* Inner circle */}
        <circle cx="24" cy="24" r="13" stroke="#cbd5e1" strokeWidth="1" fill="none" />
        {/* Pink 4-point star (concave diamond) */}
        <path
          d="M24 10 L27 21 L38 24 L27 27 L24 38 L21 27 L10 24 L21 21 Z"
          fill="#fa437f"
        />
      </svg>
    </span>
  );
};

export default StarMarker;
